import HeaderFive from "./Header-Five";

const HeaderStyleFive = () => {
  return (
    <>
      <header className="rbt-header rbt-header-9">
        <div className="rbt-sticky-placeholder"></div>
        <HeaderFive
          transparent=""
          gapSpaceBetween=""
          navigationEnd="rbt-navigation-end"
          btnClass="  btn-sm hover-transform-none rounded-1" //rbt-switch-btn btn-gradient
          btnText="Get Started"
        />
      </header>
    </>
  );
};

export default HeaderStyleFive;
